import { useMemo } from 'react'
import { t } from '@lingui/macro'
import WeeklyBarChart from '@/components/ui/charts/WeeklyBarChart'
import { useGetEstablishmentPatientsStatisticsQuery } from '@/core/services/statistics'
import { ChartSkeleton, getWeekRangeString } from '@/features/statistics'

type WeeklyPatientsProps = {
  establishmentId: string
}

export function WeeklyPatients({ establishmentId }: WeeklyPatientsProps) {
  const { data, isLoading } = useGetEstablishmentPatientsStatisticsQuery(establishmentId)

  const chart = useMemo(() => {
    return {
      labels: data?.chart.labels.map((label) => getWeekRangeString(label)) ?? [],
      datasets: data?.chart.datasets ?? [],
    }
  }, [data])

  if (isLoading) return <ChartSkeleton />

  return <WeeklyBarChart chartData={chart} title={t`Weekly Patients`} label={t`Global View`} />
}
